/*@ngInject*/
const UIFormViewerDirective = function ($document, $timeout) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let element = $($elm),
            timeoutList = [];

        element.addClass('formViewer');

        if ($scope.supplemental) {
            element.addClass('supplemental');
        }

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'E',
        transclude: true,
        scope: {
            submissionId: '@',
            formId: '@',
            isConfigurableForm: '<',
            formData: '<',
            supplemental: '@',
            lazyRender: '@',
            printPreview: '<',
            printable: '<',
            displayFormName: '<',
            effectiveDate: '@'

        },
        templateUrl: '/formViewer/formViewer.tpl.html',
        controller: 'formViewerController',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiFormViewer', UIFormViewerDirective);
